import { NgModule } from '@angular/core';

import { NgVar } from './ng-var.directive';

@NgModule({
    imports: [],
    exports: [NgVar],
    declarations: [NgVar],
    providers: [],
})
export class VarDirectiveModule { }
